module.exports = __webpack_public_path__ + "static/media/HONY_pink-hearts_700px_v2.d431b0be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/HONY_pink-hearts_700px_v2.jpg
// module id = 238
// module chunks = 1